import { faMap, faBuilding, faSquareMinus } from "@fortawesome/free-solid-svg-icons";
import { LuUtilityPole, LuNotebookPen } from "react-icons/lu";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useDispatch, useSelector } from "react-redux";
import { changeTab, newTab, setTabFromNewIndex } from "../../state/slices/tabsSlice";
import styles from "./CompInfraestrutura.module.css"
import { useState, useEffect } from "react";
import servConsultaDisponibilidade from "../../services/login/servConsultaDisponibilidade";
import servParam from "../../services/login/servParam";
import { Alert, Box, CircularProgress, Modal, Snackbar } from "@mui/material";
import { style as modalstyle } from "../../components/Loading/Loading";

const CompInfraestrutura = () => {
    const dispatch = useDispatch();
    const tabs = useSelector(state => state.tabs);
    const user = useSelector(state => state.user);
    const [openError, setOpenError] = useState(false);
    const [isConsultaDisponibilidade, setIsConsultaDisponibilidade] = useState(false);
    const [typeAlert, setTypeAlert] = useState("error");
    const [errorMessage, setErrorMessage] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [fazFiscalizacao, setFazFiscalizacao] = useState(0);

    const onClickAbrirOcupante = () => {
        dispatch(newTab({
            Nome: "Ocupante",
            Aba: 9
        }));

        dispatch(setTabFromNewIndex(9));

    }

    useEffect(() => {
        verificaConsultaDisponibilidade();
    }, []);

    const verificaConsultaDisponibilidade = async () => {
        try {
            setIsLoading(true);

            const params = await servConsultaDisponibilidade.BuscarParametros();
            const paramsGeral = await servParam.recuperarCIParametros();

            if (params && params.Content.length) {
                setIsConsultaDisponibilidade(paramsGeral.Content.DisponibilizaMapas && paramsGeral.Content.ChaveGoogle)
            }

            if (paramsGeral && paramsGeral.Content) {
                setFazFiscalizacao(paramsGeral.Content.FazFiscalizacao);
            }

        } catch (err) {
            setErrorMessage("Erro ao recuperar parâmetros.");
            setIsConsultaDisponibilidade(false);
            setTypeAlert("error");
            setOpenError(true);
        } finally {
            setIsLoading(false);
        }
    }

    const onClickAbrirConsultaDisponibilidade = async () => {
        dispatch(newTab({
            Nome: "Consultar disponibilidade de compartilhamento",
            Aba: 10
        }));

        dispatch(setTabFromNewIndex(10));
        setIsLoading(false);
    }

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            setOpenError(false);
        }

        setOpenError(false);
    }

    const onClickAbrirSolCompInfraestrutura = () => {
        dispatch(newTab({
            Nome: "Sol. compart. infraestrutura",
            Aba: 11
        }));

        dispatch(setTabFromNewIndex(11));
    }

    const onClickAbrirSolicFiscalizacao = () => {
        dispatch(newTab({
            Nome: "Solicitação de fiscalização",
            Aba: 13
        }));

        dispatch(setTabFromNewIndex(13));
    }

    return (
        <div className={styles.dashboard_main}>
            <section className={styles.dashboardSection}>
                {(Boolean(isConsultaDisponibilidade) && <button className={styles.dashboardButton} onClick={onClickAbrirConsultaDisponibilidade}>
                    <FontAwesomeIcon icon={faMap} size="2x" />
                    Consultar disponibilidade
                </button>)}
                <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                    <button
                        className={`${styles.dashboardButton} ${styles.buttonArrow}`}
                        onClick={onClickAbrirOcupante}
                        style={{
                            position: "relative",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        <FontAwesomeIcon
                            icon={faBuilding}
                            size="2x"
                            style={{
                                position: "absolute",
                                left: "34px",
                            }}
                        />
                        <span>Ocupante</span>
                    </button>

                    <button className={`${styles.dashboardButton} ${fazFiscalizacao ? styles.buttonArrow : ''}`} onClick={onClickAbrirSolCompInfraestrutura}>
                        <LuUtilityPole size="48px" />
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            Sol. compart. infraestrutura
                        </div>
                    </button>

                    {!!fazFiscalizacao && (
                        <button className={`${styles.dashboardButton}`} onClick={onClickAbrirSolicFiscalizacao}>
                            <LuNotebookPen size="46px" />
                            <div style={{ display: "flex", flexDirection: "column" }}>
                                Sol. de fiscalização
                            </div>
                        </button>
                    )}
                </div>
            </section>
            <p className={styles.merchanUseall}>Desenvolvido por <a className={styles.linkUseall} href="http://www.useall.com.br" target={"_blank"}>Useall Software</a></p>

            <Snackbar open={openError} anchorOrigin={{ vertical: 'top', horizontal: 'center' }} autoHideDuration={6000} onClose={handleClose}>
                <Alert onClose={handleClose} severity={typeAlert} sx={{ width: '100%' }}>
                    {errorMessage}
                </Alert>
            </Snackbar>

            <Modal open={isLoading}>
                <Box style={modalstyle}>
                    <CircularProgress color="inherit" />
                </Box>
            </Modal>
        </div>
    )
};

export { CompInfraestrutura };